import React, { useState } from "react";
import axios from "axios";
import "./ForgetPassword.css";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import blueLock from "../../assets/images/auth/Untitled-1.svg";
import { useTranslation } from "../../contexts/TranslationContext";

const ForgetPassword = ({ url }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const { t } = useTranslation();

  const sendEmail = async () => {
    if (!email) {
      alert(t("ErrorSendingEmail"));
      return;
    }

    try {
      const formData = new FormData();
      formData.append("cmd", "frappe.core.doctype.user.user.reset_password");
      formData.append("user", email);
      formData.append("send_code", "true");

      const response = await axios.post(url, formData);

      if (response.status === 200) {
        navigate(`/newpassword/${email}`);
      }
    } catch (error) {
      console.error(t("ErrorSendingEmail"), error);
    }
  };

  return (
    <div className="auth">
      <div className="check-email-container">
        <Container>
          <div className="forget-password-image">
            <img src={blueLock} alt="Lock" />
          </div>
          <input
            type="email"
            className="login-field user-field mt-4"
            placeholder={t("EnterYourEmail")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <button className="login-submit" onClick={sendEmail}>
            {t("Submit")}
          </button>
        </Container>
      </div>
    </div>
  );
};

export default ForgetPassword;
